import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function SupportTheHeritage() {
  return <section data-section-id="235779" id="ready-to-scale" className="dark bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-5xl">
        <div className="relative overflow-hidden rounded-lg bg-primary px-6 py-20 text-left shadow-3xl sm:px-12 sm:py-24 lg:px-16">
          {}
          <div className="absolute -right-20 -top-20 select-none opacity-10 pointer-events-none">
            <span className="font-default text-[400px] font-bold leading-none text-primary-foreground">
              N
            </span>
          </div>

          <div className="relative z-10 mx-auto max-w-3xl flex flex-col items-start gap-10">
            <h2 className="font-default text-4xl font-bold tracking-tight text-primary-foreground sm:text-5xl lg:text-6xl">
              Ready to Scale Your Global Operations?
            </h2>
            <div className="flex w-full flex-col items-center justify-start gap-4 sm:flex-row">
              <Button asChild size="lg" className="w-full bg-primary-foreground text-primary hover:bg-primary-foreground/90 sm:w-auto text-base h-14 px-8 border-none transition-all duration-300">
                <Link to="/connect">Start Consultation</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="w-full border-primary-foreground/20 bg-transparent text-primary-foreground hover:bg-primary-foreground/10 sm:w-auto text-base h-14 px-8 transition-all duration-300">
                <Link to="/our-expertise">Our Expertise</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}